module.exports = __webpack_public_path__ + "img/marcos-braga.4bb63c45.jpg";